import { Component, computed, input } from '@angular/core';

import { ImageComponent } from '@valk-nx/components/ui-image/src/lib/image.component';
import type { ImageInterface } from '@valk-nx/components/ui-image/src/lib/image.interface';
import { MiniCarouselComponent } from '@valk-nx/components/ui-mini-carousel/src/lib/mini-carousel';
import { RibbonComponent } from '@valk-nx/components/ui-ribbon/src/lib/ribbon';
import { CardImageGridComponent } from '@valk-nx/compositions/ui-card-image-grid/src/lib/card-image-grid.component';
import { cn } from '@valk-nx/core/lib/core';
import type { PhotoInterface } from '@valk-nx/core/lib/interfaces/image.interface';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	selector: 'vp-persuade-card-media',
	imports: [
		SVG_ICON_IMPORTS,
		ImageComponent,
		CardImageGridComponent,
		MiniCarouselComponent,
		RibbonComponent,
	],
	templateUrl: './persuade-card-media.component.html',
})
export class PersuadeCardMediaComponent {
	readonly images = input<PhotoInterface[] | undefined>();
	readonly variant = input<'single' | 'mini-carousel' | 'grid'>('single');
	readonly useVerticalCard = input<boolean>(false);
	readonly dynamicHeight = input<number>(0);
	readonly imageRibbon = input<string | undefined>(undefined);
	readonly isTransparentImage = input<boolean>(false);
	readonly aspectRatio = input<'3:2' | '4:3' | '16:9'>('3:2');

	readonly cn = cn;

	readonly carouselItems = computed<ImageInterface[] | undefined>(() =>
		this.images()?.map((image) => ({
			src: image.src,
			altText: image.alt,
			width: 0,
			height: 0,
		})),
	);

	readonly imageClass = computed(() =>
		this.cn(
			'size-full object-cover',
			this.useVerticalCard()
				? 'card-image-border-radius-t'
				: 'card-image-border-radius-t md:card-image-border-radius-l',
			this.isTransparentImage() && 'opacity-50',
		),
	);

	readonly gridSize = computed<'small' | 'base'>(() =>
		this.useVerticalCard() ? 'base' : 'small',
	);

	readonly imageVariant = computed<
		'single' | 'modal-carousel' | 'mini-carousel' | 'grid'
	>(() => {
		if (this.images()?.length === 1) {
			return 'single';
		}

		return this.variant();
	});
}
